import { OperationContext } from '../../operations/enums/OperationContext';
import { OperationType } from '../../operations/enums/OperationType';

export class KeyOperation {
  constructor(
    private readonly id: number,
    private readonly reportId: number,
    private readonly context: OperationContext,
    private readonly type: OperationType,
    private readonly algorithms: string[] | null,
    private readonly keyRoles: string[]
  ) {}

  getId() {
    return this.id;
  }

  getReportId() {
    return this.reportId;
  }

  getContext() {
    return this.context;
  }

  getType() {
    return this.type;
  }

  getAlgorithms() {
    return this.algorithms ?? [];
  }

  getKeyRoles() {
    return this.keyRoles;
  }
}
